import { ActionReducer, Action, State } from '@ngrx/store'
import { Contact } from '@models/contact'
import { ContactsStore } from "@store/contacts"
import { Absence } from "@models/absence";

export const contactsReducer: ActionReducer<ContactsStore> = (state: ContactsStore = new ContactsStore(), action: Action) => {
  switch(action.type) {
    case POPULATE_CONTACTS:
      return new ContactsStore(
        [...action.payload],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case ADD_CONTACT:
      return new ContactsStore(
        [...state.contacts, action.payload],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case REPLACE_CONTACT:
      const p = action.payload
      const contacts: Contact[] = state.contacts.map((c: Contact) => {
        if (c.id === p.id) { return p }; return c;
      })
      const active = state.activeContact.id === p.id ? p : Contact.clone(state.activeContact)
      const editable = state.editableContact.id === p.id ? p : Contact.clone(state.editableContact)
      return new ContactsStore(
        contacts,
        active,
        editable,
        state.editableAbsence,
        [...state.students])

    case POPULATE_EDITABLE_CONTACT:
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        action.payload,
        state.editableAbsence,
        [...state.students])

    case POPULATE_ACTIVE_CONTACT:
      return new ContactsStore(
        [...state.contacts],
        action.payload,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case POPULATE_ACTIVE_CONTACT_ENROLMENTS:
      state.activeContact.enrolments = action.payload
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case RESET_CONTACT_ERRORS:
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        Contact.clone(Object.assign({}, action.payload, { errors: {} })),
        state.editableAbsence,
        [...state.students])

    case RESET_EDITABLE_CONTACT:
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        null,
        state.editableAbsence,
        [...state.students])

    case REMOVE_CONTACT:
      return new ContactsStore(
        state.contacts.filter(contact => contact.id !== action.payload.id),
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case CREATE_CONTACT_FAILURE:
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        Contact.clone(Object.assign({}, state.editableContact, action.payload)),
        state.editableAbsence,
        [...state.students])

    case UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT:
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        Absence.clone(Object.assign({}, state.editableAbsence, { classesBetween: action.payload })),
        [...state.students])

    case POPULATE_STUDENTS:
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...action.payload])

    case CREATED_DOCUMENT:
      state.activeContact.documents.push(action.payload)
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case DELETED_DOCUMENT:
      state.activeContact.documents = 
        state.activeContact.documents.filter(d => d.id != action.payload)
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case CREATED_NOTE:
      state.activeContact.notes.push(action.payload)
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case DELETED_NOTE:
      state.activeContact.notes = 
        state.activeContact.notes.filter(n => n.id != action.payload)
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case DELETED_ADDRESS:
      state.activeContact.addresses = 
        state.activeContact.addresses.filter(a => a.id != action.payload)
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    case DELETED_PHONE:
      state.activeContact.phones = 
        state.activeContact.phones.filter(p => p.id != action.payload)
      return new ContactsStore(
        [...state.contacts],
        state.activeContact,
        state.editableContact,
        state.editableAbsence,
        [...state.students])

    default:
      return state
  }
}

export const FETCH_CONTACTS = 'FETCH_CONTACTS'
export const FETCH_CONTACTS_FAILURE = 'FETCH_CONTACTS_FAILURE'
export const FETCH_CONTACT = 'FETCH_CONTACT'
export const FETCH_CONTACT_FAILURE = 'FETCH_CONTACT_FAILURE'
export const POPULATE_CONTACTS = 'POPULATE_CONTACTS'
export const POPULATE_EDITABLE_CONTACT = 'POPULATE_EDITABLE_CONTACT'
export const POPULATE_ACTIVE_CONTACT = 'POPULATE_ACTIVE_CONTACT'
export const FETCH_ACTIVE_CONTACT_ENROLMENTS = 'FETCH_ACTIVE_CONTACT_ENROLMENTS'
export const FETCH_ACTIVE_CONTACT_ENROLMENTS_FAILURE = 'FETCH_ACTIVE_CONTACT_ENROLMENTS_FAILURE'
export const POPULATE_ACTIVE_CONTACT_ENROLMENTS = 'POPULATE_ACTIVE_CONTACT_ENROLMENTS'
export const ADD_CONTACT = 'ADD_CONTACT'
export const REPLACE_CONTACT = 'REPLACE_CONTACT'
export const RESET_CONTACT_ERRORS = "RESET_CONTACT_ERRORS"
export const RESET_EDITABLE_CONTACT = "RESET_EDITABLE_CONTACT"
export const REMOVE_CONTACT = 'REMOVE_CONTACT'
export const CREATE_CONTACT = 'CREATE_CONTACT'
export const CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE'
export const FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT = 'FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT'
export const UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT = 'UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT'
export const CREATE_ABSENCE = 'CREATE_ABSENCE'
export const CREATE_ABSENCE_FAILURE = 'CREATE_ABSENCE_FAILURE'
export const DELETE_ABSENCE = 'DELETE_ABSENCE'
export const DELETE_ABSENCE_FAILURE = 'DELETE_ABSENCE_FAILURE'
export const FETCH_STUDENTS = 'FETCH_STUDENTS'
export const FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE"
export const POPULATE_STUDENTS = 'POPULATE_STUDENTS'
export const CREATE_DOCUMENT = 'CREATE_DOCUMENT'
export const CREATED_DOCUMENT = 'CREATED_DOCUMENT'
export const CREATE_DOCUMENT_FAILURE = 'CREATE_DOCUMENT_FAILURE'
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const DELETED_DOCUMENT = 'DELETED_DOCUMENT'
export const DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE'
export const CREATE_NOTE = 'CREATE_NOTE'
export const CREATED_NOTE = 'CREATED_NOTE'
export const CREATE_NOTE_FAILURE = 'CREATE_NOTE_FAILURE'
export const DELETE_NOTE = 'DELETE_NOTE'
export const DELETED_NOTE = 'DELETED_NOTE'
export const DELETE_NOTE_FAILURE = 'DELETE_NOTE_FAILURE'
export const DELETE_ADDRESS = 'DELETE_ADDRESS'
export const DELETED_ADDRESS = 'DELETED_ADDRESS'
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE'
export const DELETE_PHONE = 'DELETE_PHONE'
export const DELETED_PHONE = 'DELETED_PHONE'
export const DELETE_PHONE_FAILURE = 'DELETE_PHONE_FAILURE'
export const PERFORM_ACADEMIC_ROLLOVER = 'PERFORM_ACADEMIC_ROLLOVER'
export const PERFORMED_ACADEMIC_ROLLOVER = 'PERFORMED_ACADEMIC_ROLLOVER'
export const ACADEMIC_ROLLOVER_FAILURE = 'ACADEMIC_ROLLOVER_FAILURE'
export const APPLY_DISCOUNT = 'APPLY_DISCOUNT'
export const APPLIED_DISCOUNT = 'APPLIED_DISCOUNT'
export const APPLY_DISCOUNT_FAILURE = 'APPLY_DISCOUNT_FAILURE'
export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT'
export const REMOVE_DISCOUNT_SUCCESS = 'REMOVE_DISCOUNT_SUCCESS'
export const REMOVE_DISCOUNT_FAILURE = 'REMOVE_DISCOUNT_FAILURE'



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/contacts.ts